import { useState } from "react";
import { Button } from "swing-components";

import { CloudinaryUploadAnswerType } from "~onboarding/utils";
import { CloudinaryResult, openUploadWidget } from "~utils";

type CloudinaryUploadAnswerProps = Omit<CloudinaryUploadAnswerType, "type"> & {
  /**
   * The function to be called when a file is uploaded
   */
  onChange: (value: string) => void;
  /**
   * Disables the ability to upload files
   */
  isReadOnly?: boolean;
};

export function CloudinaryUploadAnswer(props: CloudinaryUploadAnswerProps) {
  const { label, onChange, isReadOnly } = props;
  const [isUploading, setIsUploading] = useState(false);

  /***** Handlers *****/
  function handleUploadClick() {
    setIsUploading(true);

    openUploadWidget((error: object, result: CloudinaryResult) => {
      setIsUploading(false);

      if (error) {
        // eslint-disable-next-line no-console
        console.error("Cloudinary upload error:", error);
        return;
      }

      if (result && result.event === "success" && result.info?.secure_url) {
        // Pass the secure_url directly to the parent component
        onChange(result.info.secure_url);
      }
    }, {});
  }

  /***** Render *****/
  return (
    <Button
      type="primary"
      status={isReadOnly ? "disabled" : isUploading ? "loading" : "enabled"}
      onClick={handleUploadClick}
      isFluid
    >
      {isUploading ? "Uploading..." : label}
    </Button>
  );
}
